import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { ICountryConfigSet } from "../interfaces/icountryconfigset";
import { IItemConfigSet } from "../interfaces/iitemconfig";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @whatItDoes A service for anything item related
 *
 * @howToUse Inject the service
 */
@Injectable()
export class CountryDataService extends BaseService {
    /**
     * Constructor for service
     * @param http angular http module
     * @param toastr toastr manager
     * @param authService Authentication Service
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Create draft entry and return the updated configset with correctly assigned IDs.
     */
    createDraft(itemConfigSet: IItemConfigSet): Observable<ICountryConfigSet> {
        return super.post(`/api/countrydata`, itemConfigSet)
            .pipe(map((res: any) => res));
    }

    /**
     * Save the modified changes (as draft) and return the updated configset with correctly assigned IDs.
     */
    save(itemConfigSet: IItemConfigSet): Observable<boolean> {
        return super.put(`/api/countrydata`, itemConfigSet)
            .pipe(map((res: any) => {
                return res ? true : false;
            }));
    }

    /**
     * Submit the modified changes
     */
    submit(data: ICountryConfigSet): Observable<ICountryConfigSet> {
        return super.put(`/api/countrydata/submit`, data)
            .pipe(map((res: any) => res));
    }

    /**
     * Reject the changes to content.
     */
    reject(data: ICountryConfigSet): Observable<ICountryConfigSet> {
        return super.put(`/api/countrydata/reject`, data)
            .pipe(map((res: any) => res));
    }

    /**
     * Removes a draft
     */
    deleteDraft(countryCode: string): Observable<boolean> {
        return super.delete(`/api/countrydata/${countryCode}`)
            .pipe(map((res: any) => {
                return res ? true : false;
            }));
    }
}




